<template>
  <div class="pt-3 justify-content-center">
    <tools></tools>
  </div>
</template>
<script>
import store from './../../mixins/store.mixin'
import Tools from "./Tools.vue";

export default {
  name: "ToolsMobile",
  props: {},
  components: {Tools},
  mixins: [
    store
  ],
  data() {
    return {};
  },
  mounted: function () {
  },
  created: function () {
  },
  methods: {},
  computed: {}
};
</script>
<style lang="scss" scoped>
</style>
